/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import PaginationModel from './PaginationModel';
import WhiteListIpDto from './WhiteListIpDto';

/**
 * The SearchingQueryResponseModelWhiteListIpDto model module.
 * @module model/SearchingQueryResponseModelWhiteListIpDto
 * @version v1.0.0
 */
class SearchingQueryResponseModelWhiteListIpDto {
    /**
     * Constructs a new <code>SearchingQueryResponseModelWhiteListIpDto</code>.
     * @alias module:model/SearchingQueryResponseModelWhiteListIpDto
     */
    constructor() { 
        
        SearchingQueryResponseModelWhiteListIpDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SearchingQueryResponseModelWhiteListIpDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SearchingQueryResponseModelWhiteListIpDto} obj Optional instance to populate.
     * @return {module:model/SearchingQueryResponseModelWhiteListIpDto} The populated <code>SearchingQueryResponseModelWhiteListIpDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SearchingQueryResponseModelWhiteListIpDto();

            if (data.hasOwnProperty('pagination')) {
                obj['pagination'] = PaginationModel.constructFromObject(data['pagination']);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], [WhiteListIpDto]);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/PaginationModel} pagination
 */
SearchingQueryResponseModelWhiteListIpDto.prototype['pagination'] = undefined;

/**
 * search result list
 * @member {Array.<module:model/WhiteListIpDto>} result
 */
SearchingQueryResponseModelWhiteListIpDto.prototype['result'] = undefined;






export default SearchingQueryResponseModelWhiteListIpDto;

